import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ResumeCard from '../../MyPage/MyApply/Resumes/MyResumes/ResumeCard';
import EmptyResume from './EmptyResume';
import { useIsMobile } from '@repo/common';

import { getAllCareers } from '../../../api/career/career.api';

const MyResumeCard = ({ onStandardSuccess, onDeleteSuccess, isCareerPage }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [resumeData, setResumeData] = useState([]);
  // 불러오기 전·실패(비로그인 등)에는 empty 를 띄우지 않는다
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchCareers = async () => {
    try {
      const data = await getAllCareers();
      setResumeData(data);
      setIsLoaded(true);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchCareers();
  }, []);

  const MAX_COUNT = 3;
  const visibleCareers = resumeData.slice(0, MAX_COUNT);

  if (isLoaded && !resumeData?.length) return <EmptyResume />;

  return (
    <div
      className='
    flex flex-row overflow-x-auto
    tabletH:grid tabletH:grid-cols-[repeat(auto-fill,minmax(320px,1fr))]
    tabletH:overflow-x-visible
    gap-4 tabletH:gap-6
  '
    >
      {visibleCareers.map((resume) => (
        <div key={resume.id} className='shrink-0 tabletH:shrink'>
          <ResumeCard
            resumeData={resume}
            onDeleted={() => fetchCareers()}
            onStandardSuccess={onStandardSuccess}
            onDeleteSuccess={onDeleteSuccess}
            onClick={() =>
              navigate(`/career/resumes/${resume.id}`, {
                state: {
                  title: resume.title,
                },
              })
            }
            isCareerPage={isCareerPage}
            $isMobile={isMobile}
          />
        </div>
      ))}
    </div>
  );
};

export default MyResumeCard;
